/**
 * Extracted from `contexts/exam-role-context.tsx` so Fast Refresh can preserve that file's
 * component state. A component file that also exports plain values makes
 * React remount the whole tree on every edit; these values have no JSX in
 * them, so they belong beside the component rather than inside it.
 */

import { create } from "zustand"
import {
  examRoleFromLoginSession,
  type ExamAppRole,
} from "@/lib/exam-blueprint-access"

export type UserRole = ExamAppRole

export interface ExamRoleState {
  role: UserRole
  setRole: (role: UserRole) => void
}

export const getInitialRole = (): UserRole => {
  if (typeof window !== "undefined") {
    return examRoleFromLoginSession()
  }
  return "Admin"
}

export const useExamRoleStore = create<ExamRoleState>((set) => ({
  role: getInitialRole(),
  setRole: (newRole) => {
    if (typeof window !== "undefined") {
      localStorage.setItem("exam-user-role", newRole)
    }
    set({ role: newRole })
  },
}))

export function syncExamRoleFromLoginSession(): UserRole {
  const next = examRoleFromLoginSession()
  useExamRoleStore.getState().setRole(next)
  return next
}
